import { GlassCard } from "@/components/glass-card";

/**
 * Hero media cluster: lifestyle photos + floating chat preview.
 */
export function LandingHeroVisual() {
  return (
    <div className="landing-fade-in-delay-1 relative mx-auto w-full max-w-xl pb-28 sm:pb-24 lg:max-w-none lg:pb-8">
      <div
        className="landing-orb -left-6 top-8 h-40 w-40 bg-teal-300/50"
        aria-hidden
      />
      <div
        className="landing-orb -right-4 bottom-10 h-36 w-36 bg-emerald-200/60"
        aria-hidden
      />

      <div className="relative grid grid-cols-12 gap-3">
        <div className="landing-float col-span-12 overflow-hidden rounded-3xl shadow-[0_40px_80px_-40px_rgba(15,23,42,0.55)] ring-1 ring-white/70 sm:col-span-8">
          <img
            src="/landing/prime-broker-couple.jpg"
            alt="Mortgage broker meeting happily with clients over home-buying documents"
            className="aspect-[16/10] h-full w-full object-cover"
            width={960}
            height={600}
            fetchPriority="high"
            decoding="async"
          />
        </div>

        <div className="col-span-12 grid grid-cols-2 gap-3 sm:col-span-4 sm:grid-cols-1">
          <div className="landing-float-delay overflow-hidden rounded-2xl shadow-lg ring-1 ring-white/70">
            <img
              src="/landing/prime-happy-homeowners.jpg"
              alt="Happy homeowners with keys outside their new home"
              className="aspect-[4/3] h-full w-full object-cover"
              width={480}
              height={360}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="landing-float-delay-2 overflow-hidden rounded-2xl shadow-lg ring-1 ring-white/70">
            <img
              src="/landing/prime-using-app.jpg"
              alt="Broker using Mortgage Broker Assistant on a laptop"
              className="aspect-[4/3] h-full w-full object-cover"
              width={480}
              height={360}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>

      <GlassCard className="landing-float-delay-2 absolute -bottom-4 left-3 right-3 z-10 max-w-sm shadow-[0_24px_60px_-24px_rgba(15,118,110,0.45)] sm:left-auto sm:right-6 sm:bottom-6">
        <p className="text-sm font-medium text-teal-700">Assistant · Pipeline digest</p>
        <div className="mt-3 space-y-2.5 text-sm">
          <div className="rounded-2xl bg-teal-700 px-3.5 py-2 text-white">
            Who should I call today?
          </div>
          <div className="glass-panel rounded-2xl px-3.5 py-2 text-slate-700">
            Three clients are waiting on documents. Want me to draft a note?
          </div>
          <div className="rounded-2xl bg-teal-700 px-3.5 py-2 text-white">
            Yes please
          </div>
        </div>
      </GlassCard>
    </div>
  );
}
